<template>
  <v-layout wrap class="container px-2 py-0">
    <router-view />
  </v-layout>
</template>

<script>
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('role_view', next);
  },
};
</script>

<style></style>
